export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11552.c9e7ff1a.jpg";